import classNames from "classnames"

import TabContent, { BenefitDriverTabInfo } from "./TabContent"
import { Color } from "../../../../constants/V2/color"

import React from "react"

type Props = BenefitDriverTabInfo & {
  active?: boolean
  textColor: Color
}

export const ACTIVE_TAB_CLASSNAME = "benefit-driver-tab-active"

const BenefitDriverTab = ({
  active,
  textColor,
  bodyText,
  leadText,
  number,
  ctaText,
  ctaLink,
}: Props) => {
  return (
    <div
      className={classNames(
        "flex min-h-[40vh] cursor-pointer flex-col justify-center pl-8 transition-opacity duration-500",
        active ? "opacity-100" : "opacity-30"
      )}
    >
      <TabContent
        variant="desktop"
        textColor={textColor}
        leadText={leadText}
        bodyText={bodyText}
        number={number}
        ctaText={ctaText}
        ctaLink={ctaLink}
      />
    </div>
  )
}

export default BenefitDriverTab
